import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=28029a45&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&id=28029a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28029a45",
  null
  
)

export default component.exports